<template>
  <div class="w-full p-5">
    <apexchart
      v-if="isDataReady"
      :options="chartOptions"
      :series="series"
      type="line"
      height="400"
    />
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "ResilienceChart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isDataReady() {
      return Array.isArray(this.data) && this.data.length > 0;
    },
    series() {
      if (!this.isDataReady) return [];

      return [
        {
          name: "Benar",
          data: this.data.map((item) => Number(item.amount_answer) || 0),
        },
      ];
    },
    categories() {
      if (!this.isDataReady) return [];

      return this.data.map((item) => Number(item.column) || 0);
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (value) => value.toLocaleString(),
          style: {
            fontSize: "12px",
            fontWeight: "bold",
            borderRadius: 50, // Make data labels circular
          },
          background: {
            enabled: true,
            padding: 10,
            // borderRadius: 100,
            borderWidth: 1,
          },
        },
        stroke: {
          curve: "straight",
          width: 2,
          colors: ["#1e4db7"],
        },
        grid: {
          borderColor: "#f1f1f1",
          row: {
            colors: ["transparent"],
            opacity: 0.5,
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        markers: {
          size: 4,
          colors: ["#1e4db7"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 6,
          },
        },
        xaxis: {
          categories: this.categories,
          title: {
            text: "Kolom",
            style: {
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
          tickAmount: this.isDataReady ? this.data.length : 5,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          axisTicks: {
            show: true,
            borderType: "solid",
            color: "#78909C",
            height: 6,
            offsetX: 0,
            offsetY: 0,
          },
        },
        yaxis: {
          title: {
            text: "Jumlah Benar",
            color: "#000",
            style: {
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title",
            },
          },
          min: 0,
          max: this.isDataReady
            ? Math.ceil(
                Math.max(
                  ...this.data.map((item) => Number(item.amount_answer) || 0)
                ) / 5
              ) * 8
            : 100,
          tickAmount: 4,
          labels: {
            style: {
              fontSize: "12px",
            },
            formatter: (value) => Math.round(value).toString(),
          },
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            if (!this.isDataReady) return "";

            const value = series[seriesIndex][dataPointIndex];
            // const maxValue = Math.max(...series[seriesIndex]);
            // const percentage = ((value / maxValue) * 100).toFixed(1);

            return (
              '<div class="custom-tooltip" style="padding: 12px; background: #fff; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">' +
              '<div style="font-weight: 600; margin-bottom: 8px; color: #1e4db7; font-size: 13px;">' +
              `Kolom ${this.categories[dataPointIndex]}` +
              "</div>" +
              '<div style="display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 12px;">' +
              '<span style="color: #666;">Jumlah Benar:</span>' +
              `<span style="font-weight: 600; margin-left: 12px; color: #333;">${value}</span>` +
              "</div>" +
              "</div>"
            );
          },
          y: {
            formatter: (value) => `${value} jawaban`,
          },
          fixed: {
            enabled: false,
            position: "topRight",
            offsetX: 0,
            offsetY: 0,
          },
          style: {
            fontSize: "12px",
            fontFamily: "inherit",
          },
        },
        title: {
          align: "center",
          style: {
            fontSize: "16px",
            fontWeight: 600,
            fontFamily: "inherit",
            color: "#333",
          },
        },
        theme: {
          mode: "light",
          palette: "palette1",
          monochrome: {
            enabled: false,
            color: "#1e4db7",
            shadeTo: "light",
            shadeIntensity: 0.65,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
  },
  mounted() {},
};
</script>
